import { BaseApi } from "./baseApi";
import { PumpAccessDto } from "../dtos/pumpaccess";

export class PumpAccessApi extends BaseApi<PumpAccessDto> {
  constructor(baseUri: string, enqueueSnackbar?: any, logout?: () => void) {
    super(baseUri, "pumpAccess", logout, enqueueSnackbar);
  }
}
